module.exports = __webpack_public_path__ + "static/media/cluster25ext.7907da65.png";